import { Search } from "lucide-react";
import { DocumentCard } from "./DocumentCard";

interface SearchResult {
  _id?: string;
  id?: string;
  fileName?: string;
  title?: string;
  summary?: string | null;
  processingStatus?: string | null;
  fileType?: string | null;
}

interface DocumentListCardProps {
  results: SearchResult[];
}

function normalizeResult(result: SearchResult) {
  return {
    id: String(result._id ?? result.id ?? ""),
    fileName: result.fileName ?? result.title ?? "Unknown Document",
    summary: result.summary ?? null,
    processingStatus: result.processingStatus ?? null,
    fileType: result.fileType ?? null,
  };
}

export function DocumentListCard({ results }: DocumentListCardProps) {
  if (!results.length) return null;

  return (
    <div className="mt-2 space-y-1.5">
      <div className="flex items-center gap-1.5 text-[11px] font-medium text-muted uppercase tracking-wider">
        <Search size={12} />
        <span>
          {results.length} document{results.length !== 1 ? "s" : ""} found
        </span>
      </div>
      <div className="space-y-1.5">
        {results.map((result) => {
          const doc = normalizeResult(result);
          return <DocumentCard key={doc.id} document={doc} />;
        })}
      </div>
    </div>
  );
}
